import { defineStore } from 'pinia'
import { ref } from 'vue'

type Notice = {
  message: string
  ttl?: number
  type: 'error' | 'info' | 'success' | 'warning'
}

export const useNoticeStore = defineStore('notice', () => {
  const content = ref<undefined | Notice>(undefined)
  const timeout = ref<number | undefined>(undefined)

  const $reset = () => {
    if (timeout.value) {
      clearTimeout(timeout.value)
    }
    content.value = undefined
    timeout.value = undefined
  }

  const clear = () => {
    content.value = undefined
  }

  const set = (notice: Notice) => {
    content.value = notice

    if (notice.ttl && notice.ttl > 0) {
      if (timeout.value) {
        clearTimeout(timeout.value)
      }

      timeout.value = setTimeout(clear, notice.ttl)
    }
  }

  return {
    content,
    $reset,
    clear,
    set,
  }
})
